export default {"src":"/_next/static/media/yahoo-icon.f7dadc57.svg","height":3011,"width":3386,"blurWidth":0,"blurHeight":0};